import { API } from "../../../utils";

export const getPushNotification = async (
  query = {},
  pagination = { pageIndex: 1, pageSize: 50 },
) => {
  const { pageIndex = 1, pageSize = 50 } = pagination;
  const url = `push-notifications?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};

export const getPushNotificationDetails = async (id) => {
  const res = await API.get(`push-notifications/${id}`);
  return res.data;
};

export const updatePushNotification = async (id, payload) => {
  const res = await API.post(`push-notifications/${id}`, payload);
  return res.data;
};

export const createPushNotification = async (payload) => {
  const res = await API.post(`push-notifications`, payload);
  return res.data;
};

export const deletePushNotificationById = async (id) => {
  const res = await API.delete(`push-notifications/${id}`);
  return res.data;
};